const ZONE_KEYS_NAMES = {
	WALK_ON: 'Walk On',
	WALK_OFF: 'Walk Off',
	STRETCH: 'Stretch',
};

module.exports = {
	ZONE_KEYS_NAMES,
};
